import { useEffect } from 'react';

import { IRuntimeAppSettings } from '@model';
import {
  useHttpClientAsync,
  GRAPHQL_HEADER,
  httpMethods,
  IGeneralRequestResponse,
  IGraphQlQuery,
  IHttpClientResponse,
} from '@services/httpClientService';
import { nonAwaitedPromiseHandlerParametrized } from '@utils/async';

import { ApiSectionNamespace } from '../apiConstants';

import { CHECKOUT_APP_CONFIG_QUERY } from './graphql';
import { transformAppConfiguration } from './mapper';
import { IApplicationSettingsGatewayResponse } from './model';

const mappingFunction = (result: IApplicationSettingsGatewayResponse): IGeneralRequestResponse<IRuntimeAppSettings> => {
  const messages: string[] = [
    ...result.aggregatedCheckoutAppConfiguration.checkoutConfiguration.messages,
    ...result.aggregatedCheckoutAppConfiguration.headerConfiguration.messages,
  ];

  return { data: transformAppConfiguration(result.aggregatedCheckoutAppConfiguration), messages };
};

export const useGetAppConfigurationOnRender = (): IHttpClientResponse<
  IGeneralRequestResponse<IRuntimeAppSettings>,
  IGraphQlQuery
> => {
  const asyncRequest = useHttpClientAsync<
    IGeneralRequestResponse<IRuntimeAppSettings>,
    IGraphQlQuery,
    IApplicationSettingsGatewayResponse
  >({
    method: httpMethods.POST,
    path: ApiSectionNamespace.EConfigurationApiKeys.CONFIG_AGGREGATED_CHECKOUT_APP_SETTINGS_URL,
    mappingFunction,
    customHeaders: GRAPHQL_HEADER,
  });

  const { request } = asyncRequest;

  useEffect(() => {
    nonAwaitedPromiseHandlerParametrized(request, { data: { query: CHECKOUT_APP_CONFIG_QUERY } });
  }, [request]);

  return asyncRequest;
};
